import CompanyAffiliatesTable from "../../components/affiliates/CompanyAffiliatesTable";


export default function CompanyAffiliates() {
    return (
        <>
            <div className="grid grid-cols-12 gap-4 md:gap-6">
                <div className="col-span-12 space-y-6">
                    <CompanyAffiliatesTable />
                </div>
            </div>
        </>
    );
}